<template>
  <div>
    <v-layout v-if="$vuetify.breakpoint.mdAndUp" column fill-height>
      <v-toolbar
        style="position: -webkit-sticky; /* Safari */
                                                          position: sticky;"
      >
        <v-toolbar-title>
          <v-icon class="grey-darken-3--text">print </v-icon> Eksporter
          pdf/bilde
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="hideDrawer">
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </v-toolbar>
      <v-layout
        column
        fill-height
        v-show="is3d"
        style="padding: 20px; height: calc(100vh - 64px);"
      >
        <p class="caption ma-4">
          Fullverdig støtte for eksport er kun tilgjengelig når kartet vises i
          2D. I 3D visning er det foreløpig kun mulig å eksportere et
          skjermbilde (jpg) av visningen. Skjermbildet vil ha samme utsnitt og
          størrelse som det du ser i nettleseren din.
        </p>
        <v-btn class="ma-4" @click="takeScreenshot">Ta skjermbilde</v-btn>
      </v-layout>
      <v-form v-show="!is3d" style="padding: 20px; height: calc(100vh - 64px);">
        <v-container>
          <v-layout> </v-layout>
          <v-flex v-show="selectedBasemap && selectedBasemap.type !== 'vector'">
            <p>
              Tips: For best mulig resultat anbefaler vi at du bruker et av våre
              vektorkart (Grå vektor, Terreng vektor, eller Basis vektor) som
              bakgrunnkart.
            </p></v-flex
          >
          <v-flex>
            <v-select
              block
              return-object
              v-model="selectedPageFormat"
              item-text="title"
              :items="pageFormats"
              box
              label="Sideoppsett"
            ></v-select>
          </v-flex>
          <v-flex>
            <v-select
              block
              v-model="selectedFileformat"
              :items="fileFormats"
              box
              label="Filformat"
            ></v-select>
          </v-flex>
          <v-flex>
            <v-select
              block
              v-model="selectedPrintScale"
              :items="scales"
              item-text="scale"
              :return-object="true"
              box
              label="Målestokk"
            >
              <template slot="selection" slot-scope="data">
                1:{{ data.item.scale.toFixed(0) }}
              </template>
              <template slot="item" slot-scope="data">
                1:{{ data.item.scale.toFixed(0) }}
              </template>
            </v-select>
          </v-flex>
          <v-flex>
            <v-select
              block
              v-model="selectedDpiOption"
              :items="dpiOptions"
              box
              label="DPI (kvalitet)"
            ></v-select>
          </v-flex>

          <v-flex>
            <v-text-field
              v-model="printTitle"
              box
              label="Tittel som skal vises på utskriften"
            ></v-text-field>
          </v-flex>

          <v-flex>
            <v-btn
              :loading="loading"
              :disabled="loading"
              @click="print"
              block
              large
              >Eksportér
            </v-btn>
          </v-flex>

          <h3 v-if="printResultUrls.length > 0">Eksporterte filer</h3>
          <v-list>
            <v-list-tile
              v-for="printResult in printResultUrls"
              :key="printResult.url"
              avatar
            >
              <v-list-tile-avatar>
                <v-icon>link</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  <a :href="printResult.url">{{
                    printResult.title
                  }}</a>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-container>
      </v-form>
    </v-layout>

    <div v-else>
      <v-toolbar absolute style="z-index: 100; width: 100vw">
        <v-toolbar-items> </v-toolbar-items>

        <v-btn :disabled="loading" @click="close" small depressed
          >Avbryt
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="loading" @click="sheet = !sheet" icon>
          <v-icon>mdi-printer-settings</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          @click="print"
          small
          color="blue"
          depressed
          dark
          >Eksporter
        </v-btn>
      </v-toolbar>

      <v-bottom-sheet
        v-if="printResultUrls.length > 0"
        v-model="downloadFileSheet"
        hide-overlay
        style="z-index: 1001; background: white;"
      >
        <v-card color="white">
          <v-layout justify-space-around row>
            <v-subheader>Eksporten er klar</v-subheader>
            <v-btn
              depressed
              @click="close"
              flat
              color="blue"
              :href="printResultUrls[0].url"
              >Åpne</v-btn
            >
          </v-layout>
        </v-card>
      </v-bottom-sheet>
      <v-bottom-sheet
        v-model="sheet"
        hide-overlay
        style="z-index: 1001; background: white;"
      >
        <v-card color="white">
          <form style="padding: 20px; ">
            <v-container>
              <v-layout> </v-layout>

              <v-flex>
                <v-select
                  block
                  return-object
                  v-model="selectedPageFormat"
                  item-text="title"
                  :items="pageFormats"
                  box
                  label="Sideoppsett"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-select
                  block
                  v-model="selectedFileformat"
                  :items="fileFormats"
                  box
                  label="Filformat"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-select
                  block
                  v-model="selectedPrintScale"
                  :items="scales"
                  item-text="scale"
                  :return-object="true"
                  box
                  label="Målestokk"
                >
                  <template slot="selection" slot-scope="data">
                    1:{{ data.item.scale.toFixed(0) }}
                  </template>
                  <template slot="item" slot-scope="data">
                    1:{{ data.item.scale.toFixed(0) }}
                  </template>
                </v-select>
              </v-flex>
              <v-flex>
                <v-select
                  block
                  v-model="selectedDpiOption"
                  :items="dpiOptions"
                  box
                  label="DPI (kvalitet)"
                ></v-select>
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="printTitle"
                  box
                  label="Tittel som skal vises på utskriften"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn @click="sheet = false" block color="secondary" small
                  >Skjul innstillinger
                </v-btn>
              </v-flex>
            </v-container>
          </form>
        </v-card>
      </v-bottom-sheet>
    </div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
export default {
  name: "MapPrint",
  data: function() {
    return {
      sheet: false,
      printViewModel: null,
      printTitle: "Karteksport",
      selectedTemplate: "Tittel, kart og symbolisering",
      templates: ["Tittel, kart og symbolisering", "Kun kart"],
      downloadFileSheet: false,
      pageFormats: [
        {
          title: "A4 Liggende",
          id: "a4-landscape",
          width: 1050,
          height: 605
        },
        {
          title: "A4 Stående",
          id: "a4-portrait",
          width: 720,
          height: 840
        },
        {
          title: "A3 Liggende",
          id: "a3-landscape",
          width: 1511,
          height: 800
        },
        {
          title: "A3 Stående",
          id: "a3-portrait",
          width: 1027,
          height: 1265
        }
      ],
      scales: [
        {
          level: 0,
          resolution: 21664,
          scale: 81920000
        },
        {
          level: 1,
          resolution: 10832,
          scale: 40960000
        },
        {
          level: 2,
          resolution: 5416,
          scale: 20480000
        },
        {
          level: 3,
          resolution: 2708,
          scale: 10240000
        },
        {
          level: 4,
          resolution: 1354,
          scale: 5120000
        },
        {
          level: 5,
          resolution: 677,
          scale: 2560000
        },
        {
          level: 6,
          resolution: 338.5,
          scale: 1280000
        },
        {
          level: 7,
          resolution: 169.25,
          scale: 640000
        },
        {
          level: 8,
          resolution: 84.625,
          scale: 320000
        },
        {
          level: 9,
          resolution: 42.3125,
          scale: 160000
        },
        {
          level: 10,
          resolution: 21.15625,
          scale: 80000
        },
        {
          level: 11,
          resolution: 10.578125,
          scale: 40000
        },
        {
          level: 12,
          resolution: 5.2890625,
          scale: 20000
        },
        {
          level: 13,
          resolution: 2.64453125,
          scale: 10000
        },
        {
          level: 14,
          resolution: 1.322265625,
          scale: 5000
        },
        {
          level: 15,
          resolution: 0.6611328125,
          scale: 2500
        },
        {
          level: 16,
          resolution: 0.33056640625,
          scale: 1250
        },
        {
          level: 17,
          resolution: 0.165283203125,
          scale: 625
        }
      ],
      selectedFileformat: "pdf",
      fileFormats: ["pdf", "png32", "png8", "jpg", "gif", "eps", "svg", "svgz"],
      dpiOptions: [96, 180, 300],
      selectedDpiOption: 300,
      loader: null,
      loading: false,
      printResultUrls: []
    };
  },
  computed: {
    ...mapState({
      is3d: state => state.is3d
    }),
    ...mapState(["appTitle", "tools", "selectedBasemap"]),
    selectedPrintScale: {
      set(printScale) {
        this.setSelectedPrintScale(printScale);
      },
      get() {
        return this.$store.state.selectedPrintScale;
      }
    },
    selectedPrintWidth: {
      set(printWidth) {
        this.setPrintWidth(printWidth);
      },
      get() {
        return this.$store.state.selectedPrintWidth;
      }
    },
    selectedPrintHeight: {
      set(printHeight) {
        this.setPrintHeight(printHeight);
      },
      get() {
        return this.$store.state.selectedPrintHeight;
      }
    },
    selectedPageFormat: {
      set(pageFormat) {
        this.setSelectedPageFormat(pageFormat);
      },
      get() {
        return this.$store.state.selectedPageFormat;
      }
    },
    printActive() {
      return this.tools.print.active;
    }
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    printActive(newVal, oldVal) {
      // To accommodate different screen sizes
      if (newVal !== oldVal && newVal === true) {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.selectedPrintScale = this.scales[
            this.$theMapViewObject.zoom + 2
          ];
        } else if (this.$vuetify.breakpoint.mdAndDown) {
          this.selectedPrintScale = this.scales[
            this.$theMapViewObject.zoom + 2
          ];
        } else {
          this.selectedPrintScale = this.scales[this.$theMapViewObject.zoom];
        }
      }
    }
  },
  methods: {
    ...mapActions([
      "setSelectedPrintScale",
      "setPrintWidth",
      "setPrintHeight",
      "setSelectedPageFormat",
      "deactivateTool",
      "setShowSideMenu"
    ]),
    loadPrint: function() {
      loadModules(["esri/widgets/Print/PrintViewModel"]).then(
        function([PrintViewModel]) {
          this.printViewModel = new PrintViewModel({
            printServiceUrl: process.env.VUE_APP_PRINT_SERVICE_URL,
            view: this.$theMapViewObject
          });
        }.bind(this)
      );
    },
    takeScreenshot: function() {
      this.$theSceneViewObject.takeScreenshot().then(screenshot => {
        this.downloadScreenShot(
          this.appTitle + "_3D_skjermbilde.png",
          screenshot.dataUrl
        );
      });
    },
    close: function() {
      this.downloadFileSheet = false;
      this.deactivateTool("print");
    },
    downloadScreenShot(filename, dataUrl) {
      // the download is handled differently in Microsoft browsers
      // because the download attribute for <a> elements is not supported

      if (!window.navigator.msSaveOrOpenBlob) {
        // in browsers that support the download attribute
        // a link is created and a programmatic click will trigger the download
        const element = document.createElement("a");
        element.setAttribute("href", dataUrl);
        element.setAttribute("download", filename);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      } else {
        // for MS browsers convert dataUrl to Blob
        const byteString = atob(dataUrl.split(",")[1]);
        const mimeString = dataUrl
          .split(",")[0]
          .split(":")[1]
          .split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeString });

        // download file
        window.navigator.msSaveOrOpenBlob(blob, filename);
      }
    },
    print: function() {
      loadModules(["esri/tasks/support/PrintTemplate"]).then(
        function([PrintTemplate]) {
          this.loading = true;

          let printTemplate = new PrintTemplate({
            preserveScale: true,
            outScale: this.selectedPrintScale.scale,
            exportOptions: {
              dpi: this.selectedDpiOption
            },
            format: this.selectedFileformat,
            layout: this.selectedPageFormat.id,
            layoutOptions: {
              titleText: this.printTitle,
              scalebarUnit: "Kilometers"
            }
          });

          this.printViewModel.view = this.$theMapViewObject;

          this.printViewModel
            .print(printTemplate)
            .then(printResult => {
              this.loading = false;
              this.printResultUrls.push({
                title: this.printTitle,
                url: printResult.url
              });
              this.downloadFileSheet = true;
            })
            .catch(error => {
              console.error(error);
            });
        }.bind(this)
      );
    },
    hideDrawer: function() {
      this.setShowSideMenu(false);
    }
  },
  mounted() {
    this.loadPrint();
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
